<template>
  <div class="container page">
    <van-nav-bar class="nav-bar">
      <template #left>
        <img @click="$router.push('/')" src="img/home.png" style="width: 30px; ">
      </template>
      <template #right>
        <img @click="service" style="width: 30px; "
             src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAABXJJREFUaEPVmb2yDUEUhZdcFV7AzxMgUSVCgBClxHgCPIBCkeMF/IQkSAkQCxCQ4gnwAIr6bs06tc8+09M9c2YCXXXr3nvOme691l577e4+u/Sfj10LxH9E0p5u3pOSvnc/vPR+7vXmALBX0jlJBHteEv8PjXeSXkp6FYBNxrUNAAK9Jul6Q9ClAJ9Ieijp01QEUwFckXR/IPDPkn6loE4MBPlA0p2eZ6q4xgKA9cedVOLkvyXBpuVRWpj6QGoQcDh9iFq5MDYbYwAQ/FtJBOFB4LDHT2a8xh5AbkuKmWEOQEBE02gF0Bc8RQiTfYEflHQgAS3pnBpCjnFc7TJaBdEK4GNi/kbHuhcA4OVOHjBbciJAwC6Fi2Q8yCqv234h5VSLnFoAIA/cxiOyQ6Cwl+2zr4hjf2AuAqZwLZcMArCAGJRmDQBsonsPFkS3DEDxt9l+2vk7Hl8aBAlYpGeJUfxklEAzCDKFxIqjBuCbJPTMoIsCiIETEQSDwFlkbBHzDAQgG9gms/zONXFoqOENAcjseyLXAw4Em82O0UMj2SNjOFHUPXPanSDIZG1MMQQA6ZhxT2Lm0TjBx0IcynTtPWSECQACopBSlG4xCyUAyAb5eDABLNySBPO8P1YyGQRBModJMAhkdLTLrLOQXW81VwkAwcK2tY8ukQ6DySfvXbqsMjckIBWcxoN56dAuasdgUM0SQpfsMBlMhpT4P7pQTRal93+mPhHZJSsQ5XowaczlrQpyLmaACfB1a58P0tpfzCQdGwOO5qwSLFnNUoKsaLcOGnKJaWdECZFSEOMM6JyBxbEAr83Bvi3Sc7lJRqdx/XldYrELYbtIbNVMI4A8GROhPbf3QT9u0BMkQBDzuo54DeZZI84fbTQSh/OhhhXgCMAPUVT2dhDbeWonrSEMSJOC5HdsiDzjNWIWbCLZ8aIEd2ReA+B0svMEfcsgSNLMsyzC/wZP/+C1aMExC/uCZMkMqvDWhbVHA3D1IyUmy8PB8tuHlT6QBI6L9M3hNWhk0ZEcfAQ7CQBMwlL0frKBW3mfFINGIrDH5719rmVuI7Au43ljOAuA2OR+dHsZB7tNg/ubnJHgkU+ccxIAUm8JudGwVrG91+guvG8TsUPR8Hzq8yOjAeQidoeeoydkHLZxmhQSdBeO9joagC2OQsIhSPNcm7kMwGtBDgP7ZkSyLN+VK0Yb9QRIhk4XOzMT8Rpenn18omI2HosA2HfF2w+yYxljKL2dOHderwDjdEoaDVa3NACvg0EAyjtSx7N2wMnbaVDzEAz4sgr0nA3QpW2zdhSdkhVnwM/aJFiT2qM5btReayA+bHhyCm3o8L4tgFxn3oJvnEVaAeQT2uA5tRL9bkn7JX1Nn4sbuGjRdh4ktdE4WwGwVmxgPruOPVaelnRX0k1JbxIAs5xrzGfzXuseAyDuWbK9ORZ0TJBfOtcwy8ck8XOxC/5eCj7uPqlDH27izYg3emuPjgWAhVEPPm72nY8vSXpekNEHSccl/Qnv+5xAgATsrUO8jy1ecI0F4HXjDULf9d/ZLtAz3e9nkh5Jet0DjAOKbz3ivide4eQt+GqaqQCYgB0pQAiAxjJlECSOg/RiPcWbv8FbkG0AEDBp5pwLc1NsFb1H1n1Z7DNw9Zp9WwBTWC89g0x8X0RWYj0U11kKgL8AZGEcZe0uJ0VDoGzcfJXD6Y0MNJ0tlgCQN4G231gn8WtZNyd/XRXPwNUMLwHADgXrdFf2UmwG+Tse8B0cHdbn5bGNce1Wooq28QP5ZJW/4WEaZOJvNLe5nl8EQOwRBOdvWPwV6lxX8jt8LiEhCpjA4/fAVTtszO7Gx5YA4EV8qUV/mJX1iGJJAFNJHfXcP/mqiEDZsEJxAAAAAElFTkSuQmCC">
      </template>
    </van-nav-bar>
    <div class="record">
      <van-empty v-if="list.length === 0" :description="$t('msg.没有更多了')"/>
      <div v-else class="item_list" v-for="(v,keys) in list" :key="keys">
        <div class="scroll-view-item">
          <div class="betRecord-rightTxt">
            <div class="flex-between headFrom mb-[32rpx]">
              <div class="yzj">{{ v.name }} ({{ v.expect }})</div>
              <div class="fontWarning" v-if="v.status == 0">{{ $t("正在连接") }}</div>
              <div class="fontWarning" v-else-if="v.status == 1 && v.zj_count > 0">{{ $t("已连接") }}</div>
              <div  v-else >{{ $t("未连接") }}</div>
            </div>
            <div class="u-flex flex-between mb-[24rpx]">
              <div class="u-font-24 w-[160rpx]">{{ $t("购买单类型") }}:</div>
              <div style="color: rgb(42, 53, 99); text-align: right;">{{ $t("规格") }}</div>
            </div>
            <div class="u-flex flex-between mb-[24rpx]">
              <div class="u-font-24 w-[160rpx]">{{ $t("期数") }}:</div>
              <div style="color: rgb(42, 53, 99); text-align: right;">{{ v.expect.substring(v.expect.length - 3) }}</div>
            </div>
            <div class="u-flex flex-between mb-[24rpx]">
              <div class="u-font-24 w-[160rpx]">{{ $t("投注号码") }}:</div>
              <div style="color: rgb(42, 53, 99); text-align: right;">
                  <span v-for="(item,key) in v.match_number_result" :key="key">
                    <span v-if="key > 0">,</span>
                    <span>{{ $t(item) }}</span>
                  </span>
              </div>
            </div>
            <div class="u-flex flex-between mb-[24rpx]">
              <div class="u-font-24 w-[160rpx]">{{ $t("订单时间") }}:</div>
              <div style="color: rgb(42, 53, 99); text-align: right;">{{ v.create_time }}</div>
            </div>
            <div class="u-flex flex-between mb-[24rpx]">
              <div class="u-font-24 w-[160rpx]">{{ $t("连接代码") }}:</div>
              <div style="color: rgb(42, 53, 99); text-align: right;" v-if="v.status == 1">
                  <span v-for="(item,key) in v.opencode" :key="key">
                    <span v-if="key > 0">,</span>
                    <span>{{ item }}</span>
                  </span>

              </div>
            </div>
            <div class="u-flex flex-between">
              <div class="u-font-24 w-[160rpx]">{{ $t("钱") }}:</div>
              <div style="color: rgb(42, 53, 99); text-align: right;">
                {{ formatNumber(v.money) }}, {{ $t("单个连接数") }}:{{ v.zj_count }}, {{ $t("连接金额") }}:{{ formatNumber(v.zj_num) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      list: [],
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    //客服
    service() {
      window.location.href = this.$store.getters.getBaseInfo.kefu;
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t('msg.刷新成功！'));
        this.isLoading = false;
      }, 500);
    },
    getUserGameList() {
      this.$http({
        method: 'get',
        url: 'user_get_game_list'
      }).then(res => {
        if (res.code === 200) {
          this.list = res.data;
        } else if (res.code === 401) {
          this.$toast(this.$t(res.msg));
        }
      })
    }

  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({path: '/Login'})
    } else {
      this.getUserGameList();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.record{
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 24vw;
  margin-top: 16vw;
}
.scroll-view-item {
  margin: 20px 20px;
  padding: 0 .625rem 1rem;
  background: #fff;
  border-radius: .5rem;
  box-shadow: 0 5px 10px rgba(0, 0, 0, .05);
  border: 1px solid #dfe8f6;
  color: #848fac;
}

.scroll-view-item .headFrom {
  height: 2.875rem;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #dfe8f6
}

.scroll-view-item .headFrom .yzj, .scroll-view-item .headFrom .fontRed {
  color: #ff3900;
  font-size: .75rem
}

.scroll-view-item .headFrom .fontWarning {
  color: #ff7d01
}

.scroll-view-item .headFrom uni-text {
  color: #2a3563;
  font-size: .875rem
}

.scroll-view-item .flex-between {
  display: flex;
  justify-content: space-between
}
.u-flex {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.mb-\[24rpx\] {
  margin-bottom: .75rem;
}
.mb-\[32rpx\]{
  margin-bottom: 1rem;
}
.u-font-24 {
  font-size: .75rem;
}

.w-\[160rpx\] {
  width: 5rem;
}
</style>
